import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'seb-table-order',
  templateUrl: './table-order.component.html',
  styleUrls: ['./table-order.component.css'],
})
export class TableOrderComponent implements OnInit {
  @Input() sLabel: string;
  @Input() nIndex: Number;    

  constructor() { }

  ngOnInit() {
    this.drawType(this.nIndex);
  } 

  drawType(value: any) {
    return this.nIndex === value;
  }

}
